<template>
  <div class="login callback">
    <p class="callback__text">
      {{ $t('active-directory.redirecting') }}
    </p>
  </div>
</template>

<script>
import AuthenticationService from '@/services/authentication';
import SignInService from '@/domain/services/login/signIn';

export default {
  methods: {
    login() {
      const { providerName, organizationId } = this.$route?.params;
      const { code } = this.$route?.query;

      if (!providerName || !organizationId || !code) {
        this.errorOnLogin(true);
        return;
      }

      AuthenticationService.externalLogin(providerName, organizationId, code)
        .then(signInData => SignInService.proceedAfterLogin(signInData))
        .catch(error => this.errorOnLogin(Boolean(!error)));
    },
    errorOnLogin(pushAlert) {
      this.$router.push({ name: 'externo' });

      if (pushAlert) {
        this.$pushAlert({ code: 'ME093' });
      }
    },
  },
  mounted() {
    this.login();
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.callback
  &__text
    color: var(--color-danger)
</style>
